import { render, staticRenderFns } from "./TableBulkOptions.vue?vue&type=template&id=23d0838a&scoped=true"
import script from "./TableBulkOptions.vue?vue&type=script&lang=js"
export * from "./TableBulkOptions.vue?vue&type=script&lang=js"
import style0 from "./TableBulkOptions.vue?vue&type=style&index=0&id=23d0838a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d0838a",
  null
  
)

export default component.exports